import { render, staticRenderFns } from "./AuthenticationReset.vue?vue&type=template&id=17cb0826&"
import script from "./AuthenticationReset.vue?vue&type=script&lang=js&"
export * from "./AuthenticationReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17cb0826')) {
      api.createRecord('17cb0826', component.options)
    } else {
      api.reload('17cb0826', component.options)
    }
    module.hot.accept("./AuthenticationReset.vue?vue&type=template&id=17cb0826&", function () {
      api.rerender('17cb0826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthenticationReset.vue"
export default component.exports